import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import agenticCatalogPopupUrl from "../assets/agentic-catalog-popup.png?url";
import { OnboardingProps } from "../common";

export const AgenticCatalogOnboarding = memo(function AgenticCatalogOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const handleAction = () => {
    window.open("https://meetings.hubspot.com/jacob-bengtzen", "_blank");
    handleComplete();
  };

  return (
    <RedoFeatureNotificationCard
      actionText="Learn more"
      description="Optimize all your listings for new AI search channels. We structure, enrich, and optimize your data so AI agents, and the customers who use them, can find, understand, and purchase your products instantly."
      image={agenticCatalogPopupUrl}
      onAction={handleAction}
      onDismiss={handleDismiss}
      title="Introducing Agentic Catalog"
    />
  );
});
